import { render, staticRenderFns } from "./BrandSetting.vue?vue&type=template&id=f45b5546"
import script from "./BrandSetting.vue?vue&type=script&lang=js"
export * from "./BrandSetting.vue?vue&type=script&lang=js"
import style0 from "./BrandSetting.vue?vue&type=style&index=0&id=f45b5546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports